import React from "react";
import { Route, Routes } from "react-router-dom";
import DashBoard from "../pages/dashBoard";
import AddProduuct from "../pages/AddProduct";
import routesName from '../utils/routes.json'
import AddCategory from "../pages/AddCategory";
import Orderlist from "../pages/Orderlist";
import Logout from "../pages/Logout";
import ChatPanel from "../pages/ChatPanel";
import Payment from "../pages/Payment"
import Sports from "../pages/Sports"
import ProductDashboard from "../pages/ProductDashboard";
import AddProduct from "../pages/AddProduct";
import ProductDashboardLayout from "./Layouts/ProductDashboardLayout";
import Analytics from "../pages/analytics";
import OrderStatusAnalytics from "../pages/OrderStatusAnalytics";
import SalesAnalytics from "../pages/SalesAnalytics";
import Sales from "../pages/Sales";
import OnSalesProducts from "../pages/OnSalesProducts";
function ContentComponent() {
  return (
    <Routes>
      <Route path="/" element={<DashBoard />} />
      <Route path="/Dashboard" element={<div>Home</div>} />
      <Route path="/product-dashboard" element={<ProductDashboardLayout />} >
        <Route index element={<ProductDashboard />} />
        <Route path="add-product" element={<AddProduct />} />
        <Route path="edit-product/:productId" element={<AddProduct />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="orderstatusanalytics" element={<OrderStatusAnalytics/>}  />
        <Route path="salesanalytics" element={<SalesAnalytics/>}  />
      </Route>
      

      <Route path={routesName["add-category"]} element={<AddCategory />} />
      <Route path={routesName["pay-ment"]} element={<Payment />} />
      <Route path={routesName["support-s"]} element={<Sports />} />
      <Route path={routesName["Order-list"]} element={<Orderlist />} />
      <Route path={routesName["sale-s"]} element={<ProductDashboardLayout />} >
        <Route index element={<Sales />} />
        <Route path="onsales-products/:saleId" element={<OnSalesProducts/>}/>


      </Route>
      <Route path={routesName["chat-panel"]} element={<ChatPanel />} />
      <Route path={routesName["Log-out"]} element={<Logout />} />
      <Route path="/AddCategory" element={<div>Home</div>} />

    </Routes>
  );
}

export default ContentComponent;
